var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0094D9;}\n\t.st1{fill:#EAEAEA;}\n\t.st2{fill:#028ABF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,8.4H2.1c-0.3,0-0.6-0.3-0.6-0.6V1.1c0-0.3,0.3-0.6,0.6-0.6h3.6l1.9,1.9v5.4C7.5,8.2,7.2,8.4,6.9,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,2.4H5.6V0.6L7.5,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.6,2.4l1.9,1.9V2.4H5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.8,4.3h3.4v0.4H2.8V4.3z M2.8,5.1h3.4v0.4H2.8V5.1z M2.8,5.8h3.4v0.4H2.8V5.8z M2.8,6.6h1.9v0.4H2.8V6.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.8584f627234c635eeb268ed9b6a6d105.svg";
export { ForwardRef as ReactComponent };